import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import UnifiedNavigation from 'Pods/UnifiedNavigation/UnifiedNavigation'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import Breadcrumbs from './Breadcrumbs'

function Header({
  navigation,
  navClass,
  navContainerClass,
  navId,
  breadcrumbs = EMPTY_ARRAY,
  button = null,
  newRoyaltyUi = false,
}) {
  return (
    <Fragment>
      <div className={navContainerClass}>
        <UnifiedNavigation {...navigation} navClass={navClass} navId={navId} isInFastPage={false} />
      </div>
      {breadcrumbs.length > 0 && (
        <Breadcrumbs
          list={breadcrumbs}
          cta={button}
          newRoyaltyUi={newRoyaltyUi}
        />
      )}
    </Fragment>
  )
}

Header.propTypes = {
  navigation: PropTypes.object.isRequired,
  navClass: PropTypes.string.isRequired,
  navContainerClass: PropTypes.string.isRequired,
  navId: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.array,
  button: PropTypes.element,
  history: PropTypes.object,
  newRoyaltyUi: PropTypes.bool,
}

export default Header
